import { apiCall } from "../helpers/api";


export const states = (params = {}) => (dispatch) => {
  params.path = params.path || "regions/states";
  return dispatch(apiCall(params));
}